var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 75,
    viewBox: "0 0 79 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8958 18.021H59.9329M20.9583 2.0835H58.0417C68.2819 2.0835 76.5833 10.0118 76.5833 19.7918V55.2085C76.5833 64.9885 68.2819 72.9168 58.0417 72.9168H20.9583C10.7181 72.9168 2.41667 64.9885 2.41667 55.2085V19.7918C2.41667 10.0118 10.7181 2.0835 20.9583 2.0835ZM54.3333 35.2689C54.791 38.2164 54.2638 41.2268 52.8269 43.8717C51.3899 46.5166 49.1163 48.6614 46.3294 50.0011C43.5425 51.3408 40.3842 51.8071 37.3039 51.3337C34.2235 50.8603 31.3779 49.4713 29.1717 47.3643C26.9655 45.2573 25.5112 42.5395 25.0155 39.5976C24.5198 36.6557 25.0081 33.6394 26.4108 30.9777C27.8135 28.3161 30.0593 26.1447 32.8287 24.7723C35.598 23.3999 38.75 22.8964 41.8363 23.3335C44.9843 23.7793 47.8988 25.1803 50.1492 27.3296C52.3996 29.4788 53.8665 32.2623 54.3333 35.2689Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsInstagram);
export default __webpack_public_path__ + "static/media/ms_instagram.c87daa5b34f76f788851b10acb46f6ed.svg";
export { ForwardRef as ReactComponent };